import { QueryClient, QueryKey, QueryState } from '@tanstack/react-query';

type QueryEntryState = Pick<QueryState, 'status' | 'fetchStatus' | 'error'>;

export const getQueryStates = (
  queryClient: QueryClient,
  queryKeys: readonly QueryKey[]
): QueryEntryState[] => {
  return queryKeys.map(queryKey => {
    const state = queryClient.getQueryState(queryKey);

    return {
      status: state?.status ?? 'pending',
      fetchStatus: state?.fetchStatus ?? 'idle',
      error: state?.error ?? null
    };
  });
};

export const getCacheSignature = (queryClient: QueryClient, queryKeys: readonly QueryKey[]) => {
  return queryKeys
    .map(queryKey => {
      const state = queryClient.getQueryState(queryKey);

      return `${JSON.stringify(queryKey)}:${state?.status ?? 'pending'}:${state?.fetchStatus ?? 'idle'}:${state?.errorUpdateCount ?? 0}:${state?.dataUpdatedAt ?? 0}`;
    })
    .join('|');
};
